import {
  APP_ROUTES,
  FEATURE_TOUR_KEYS,
} from "../../constants/global.constants";

const buildConditionalSixthStep = (t, currentPage = "") => {
  if (
    currentPage.includes(APP_ROUTES.ADD_PLANT) ||
    currentPage.includes(APP_ROUTES.EDIT_PLANT)
  ) {
    return {
      target: "#chemical-selection-fields",
      placement: "top",
      isFixed: true,
      title: t("featureTour.plantChemicalSelectionTitle"),
      content: t("featureTour.plantChemicalSelectionDescription"),
    };
  }

  if (currentPage.includes(APP_ROUTES.ANALYSE_DATA)) {
    return {
      target: "#train-chemical-acid-selection",
      placement: "top",
      isFixed: true,
      title: t("featureTour.trainChemicalDataTitle"),
      content: t("featureTour.trainChemicalDataDescription"),
    };
  }

  return null;
};

export const featureTourSteps = (t, currentPage) => {
  const chemicalUtilityCostSteps = [
    {
      target: "#plant-chemical-library",
      placement: "left",
      title: t("featureTour.plantChemicalLibraryTitle"),
      content: t("featureTour.plantChemicalLibraryDescription"),
    },
    {
      target: "#plant-utility-costs",
      placement: "right",
      title: t("featureTour.plantUtilityCostsTitle"),
      content: t("featureTour.plantUtilityCostsDescription"),
    },
    {
      target: "#user-profile",
      placement: "bottom",
      title: t("featureTour.userProfileTitle"),
      content: t("featureTour.userProfileDescription"),
    },
    {
      target: "#user-chemical-library",
      placement: "left",
      title: t("featureTour.userChemicalLibraryTitle"),
      content: t("featureTour.userChemicalLibraryDescription"),
    },
    {
      target: "#user-utility-costs",
      placement: "left",
      title: t("featureTour.userUtilityCostsTitle"),
      content: t("featureTour.userUtilityCostsDescription"),
    },
  ];

  const conditionalSixthStep = buildConditionalSixthStep(t, currentPage);
  if (conditionalSixthStep) {
    chemicalUtilityCostSteps.push(conditionalSixthStep);
  }

  return {
    [FEATURE_TOUR_KEYS.CHEMICAL_UTILITY_COST]: chemicalUtilityCostSteps,
  };
};
